import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getMemberBpjs(params) {
	return client.get("dashboard/member-status", {
		params: params,
	});
}

function getCertificate(params) {
	return client.get("binary/member/data-certificate", {
		params: params,
	});
}

function getSummaryBonus(params) {
	return client.get("binary/bonus/summary", {
		params: params,
	});
}

function getMemberGrowPerWeek(params) {
	return client.get("dashboard/member-grow-per-week", {
		params: params,
	});
}

function getTotalDownline(params) {
	return client.get("binary/network/total-downline", {
		params: params
	});
}

function getTenNewDownline(params) {
	return client.get("binary/network/ten-new-downline", {
		params: params
	});
}

export default {
	getMemberBpjs,
	getCertificate,
	getSummaryBonus,
	getMemberGrowPerWeek,
	getTotalDownline,
	getTenNewDownline,
};